<p class="intro-text">
  {{ 'STEP6.INTRODUCTIONTEXT' | translate }}
</p>

<div class="finishes">
  <div class="finish-outside">
    <div class="text" *ngIf="selectedWall === undefined; else specificExternalWall">
      {{ 'STEP6.FINISH' | translate }} {{ 'STEP6.OUTSIDESMALL' | translate }}
    </div>
    <ng-template #specificExternalWall>
      <div class="text">
        {{ 'STEP6.FINISH' | translate }} {{ selectedWallCaption }} {{ 'STEP6.OUTSIDESMALL' | translate }}
      </div>
    </ng-template>
    <app-isomasters-horizontal-viewbox
      [options]="externalWallFinishTypes"
      [needsBorderedFlaredImage]="true"
      (optionSelected$)="processSelectedExternalWallFinish($event)"></app-isomasters-horizontal-viewbox>
  </div>

  <div class="finish-inside">
    <div class="text" *ngIf="selectedWall === undefined; else specificInternalWall">
      {{ 'STEP6.FINISH' | translate }} {{ 'STEP6.INSIDESMALL' | translate }}
    </div>
    <ng-template #specificInternalWall>
      <div class="text">
        {{ 'STEP6.FINISH' | translate }} {{ selectedWallCaption }} {{ 'STEP6.INSIDESMALL' | translate }}
      </div>
    </ng-template>
    <app-isomasters-horizontal-viewbox
      [options]="internalWallFinishTypes"
      [needsBorderedFlaredImage]="true"
      (optionSelected$)="processSelectedInternalWallFinish($event)"></app-isomasters-horizontal-viewbox>
  </div>
</div>
